<template>
  <NxInput
    name="siglaUFOrgaoExpeditor"
    type="text"
    label="Sigla UF do Orgao Expeditor:"
    placeholder="Digite a sigla"
    :maxlength="3"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputSiglaUFOrgaoExpeditor',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputSiglaUFOrgaoExpeditor.vue